import { AgencyAgentOrder } from '@entities/agencies';
import { AgencyMetricHashes } from '@shared/config/metrics';
export const SortElementId = {
    [AgencyAgentOrder.TopDeals]: AgencyMetricHashes.ClickSortTopDeals,
    [AgencyAgentOrder.TopReviews]: AgencyMetricHashes.ClickSortTopReviews,
    [AgencyAgentOrder.TopRating]: AgencyMetricHashes.ClickSortTopRating
};
